<template>
  <div>
    <!-- Start Header -->
    <div class="ContentHeader">
      <div class="HeaderAll">
        <!-- Slot Breadcrumb -->
        <slot name="titlebreadcrumb"></slot>

        <a-breadcrumb>
          <a-breadcrumb-item
            ><router-link :to="{ name: 'Home' }">Home</router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item v-for="(item, i) in breadcrumb" :key="i">
            <router-link
              :to="{ name: item.nameroute }"
              v-if="i + 1 < breadcrumb.length"
              >{{ item.name }}</router-link
            >
            <span v-else>{{ item.name }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <!-- Slot Benefit Header-->
      <slot name="benefitheader"></slot>
    </div>
    <!-- End Header -->

    <!-- slot menu -->
    <slot name="menuall"></slot>
    <!-- end slot menu -->

    <div
      class="allcard"
      style="
        border-top-left-radius: 0px;
        height: fill-available;
        height: -webkit-fill-available;
        position: absolute;
        width: 100%;
      "
    >
      <simplebar class="simplebarcustom" data-simplebar-auto-hide="false">
        <!-- search -->
        <div
          class="_providersticky"
          ref="searchbar"
          style="display: flex; justify-content: flex-end"
        >
          <div class="ContentHeaderSearch contentsearchpt">
            <a-input-search
              placeholder="Search Here"
              style="width: 327px"
              @search="onSearch"
              allowClear
              :default-value="
                $route.query.search != undefined ? $route.query.search : ''
              "
            />
          </div>
        </div>
        <!-- end search -->

        <!-- start content here -->
        <a-table
          class="_providertable"
          :style="{ '--sticky-top': stickyTop + 'px' }"
          :rowKey="(record) => record.id"
          :columns="columns"
          :dataSource="data"
          :pagination="false"
          :loading="loading"
        >
          <template slot="provider" slot-scope="text, record">
            {{ providerName(record) }}
          </template>

          <!-- sebagian field dikirim sebagai array (phone bisa lebih dari satu
               nomor). tanpa ini Vue merangkai elemennya tanpa pemisah, jadi dua
               nomor terlihat seperti satu angka panjang. -->
          <template slot="cell" slot-scope="text">
            <div v-for="(item, i) in toList(text)" :key="i">{{ item }}</div>
          </template>

          <template slot="phone" slot-scope="text">
            <div v-for="(item, i) in toList(text)" :key="i" class="_phonecell">
              <a-icon type="phone" theme="filled" class="_phoneicon" />
              <span>{{ item }}</span>
            </div>
          </template>

          <template slot="flag" slot-scope="text">
            <a-icon
              v-if="isYes(text)"
              class="_flagyes"
              type="check-circle"
              theme="filled"
            />
            <a-icon
              v-else-if="isNo(text)"
              class="_flagno"
              type="close-circle"
              theme="filled"
            />
            <span v-else>{{ text }}</span>
          </template>

          <template slot="footer">
            {{ null }}
          </template>
        </a-table>
        <!-- end content -->

        <!-- pagination -->
        <div class="paginationcustom" style="margin-top: 0px !important">
          <a-pagination
            showSizeChanger
            @showSizeChange="onShowSizeChange"
            :pageSizeOptions="pageSizeOption"
            :pageSize.sync="pageSize"
            :total="total"
            v-model="page"
            :showTotal="
              (total, range) => ` ${range[0]}-${range[1]}  of ${total} `
            "
            @change="handlePageChange"
          >
            <template slot="buildOptionText" slot-scope="props">
              <span v-if="props.value !== '1000000'">
                {{ props.value }} / page
              </span>
              <span v-if="props.value == '1000000'">All</span>
            </template>
          </a-pagination>
        </div>
        <!-- end pagination -->
      </simplebar>
    </div>
  </div>
</template>

<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";

const COLUMN_WIDTH = 200;

// field yang di-mask dari tabel: id & insurance_id disembunyikan, sedangkan
// provider_name tampil lewat kolom "Provider". category TIDAK disembunyikan —
// dia jadi kolomnya sendiri.
const HIDDEN_FIELDS = ["id", "insurance_id", "provider_name"];

// field ya/tidak yang ditampilkan sebagai icon centang / silang
const FLAG_FIELDS = ["inpatient", "outpatient"];

// field nomor telepon — tiap nomor diberi icon sendiri
const PHONE_FIELDS = ["phone"];

// field yang diprioritaskan ke kolom paling depan, tepat setelah "Provider"
const LEADING_FIELDS = ["category"];

const FLAG_YES = ["1", "true", "y", "ya", "yes", "ada"];
const FLAG_NO = ["0", "false", "n", "tidak", "no"];

// header-nya "Provider" (bukan "Provider Name" hasil auto-title), isinya
// provider_name saja
const PROVIDER_COLUMN = {
  title: "Provider",
  key: "provider",
  width: 400,
  scopedSlots: { customRender: "provider" },
};

// response bisa pakai snake_case atau camelCase (insurance_id / insuranceId),
// jadi nama field dibandingkan tanpa underscore & tanpa beda huruf besar-kecil
const normalize = (key) => key.replace(/_/g, "").toLowerCase();

const HIDDEN = HIDDEN_FIELDS.map(normalize);

const FLAGS = FLAG_FIELDS.map(normalize);

const PHONES = PHONE_FIELDS.map(normalize);

const LEADING = LEADING_FIELDS.map(normalize);

const pick = (record, field) => {
  const key = Object.keys(record).find((k) => normalize(k) == normalize(field));

  return key == undefined ? null : record[key];
};

// query string bisa kosong atau bukan angka (?page=), dan Number("") == 0 —
// tanpa validasi ini request-nya jadi page=0&pageSizes=0
const toNumber = (value, fallback) => {
  const parsed = Number(value);

  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export default {
  components: {
    simplebar,
  },
  data() {
    return {
      pageSizeOption: ["15", "30", "60", "1000000"],
      total: 0,
      page: toNumber(this.$route.query.page, 1),
      pageSize: toNumber(this.$route.query.pageSizes, 15),
      loading: false,
      data: [],
      columns: [PROVIDER_COLUMN],
      stickyTop: 0,
      search:
        this.$route.query.search != undefined ? this.$route.query.search : "",
      breadcrumb: [
        {
          name: "Daftar Group",
          nameroute: "ListDaftarGroup",
          param: {},
        },
        {
          name: "Provider",
          nameroute: "",
          param: {},
        },
      ],
    };
  },
  mounted() {
    window.addEventListener("resize", this.measure);
    this.measure();

    this.fetch({
      page: this.page,
      pageSizes: this.pageSize,
      id: this.$route.params.id,
      ...this.searchParam(),
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.measure);
  },
  methods: {
    // header tabel nempel persis di bawah blok search, tingginya diukur dari
    // elemennya karena ikut berubah di breakpoint responsive (scale 0.9)
    measure() {
      this.$nextTick(() => {
        const searchbar = this.$refs.searchbar;

        if (searchbar == null) {
          return;
        }

        this.stickyTop = searchbar.offsetHeight;
      });
    },
    // sisa field selain HIDDEN_FIELDS ditampilkan apa adanya, header-nya
    // dibikin dari nama field (created_at -> "Created At")
    buildColumns(rows) {
      if (rows == undefined || rows.length == 0) {
        return [PROVIDER_COLUMN];
      }

      const visible = Object.keys(rows[0]).filter(
        (key) => HIDDEN.indexOf(normalize(key)) == -1
      );

      // LEADING_FIELDS ditarik ke depan supaya duduk tepat di sebelah kolom
      // Provider. tanpa ini urutan kolom murni mengikuti urutan key di
      // response, dan category bisa terlempar ke kolom paling kanan.
      const isLeading = (key) => LEADING.indexOf(normalize(key)) != -1;

      const rest = visible
        .filter(isLeading)
        .concat(visible.filter((key) => !isLeading(key)))
        .map((key) => {
          const column = {
            title: key
              .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
              .split("_")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" "),
            dataIndex: key,
            width: COLUMN_WIDTH,
            scopedSlots: { customRender: "cell" },
          };

          if (FLAGS.indexOf(normalize(key)) != -1) {
            column.align = "center";
            column.width = 140;
            column.scopedSlots = { customRender: "flag" };
          }

          if (PHONES.indexOf(normalize(key)) != -1) {
            column.scopedSlots = { customRender: "phone" };
          }

          return column;
        });

      return [PROVIDER_COLUMN, ...rest];
    },
    // tetap lewat pick() supaya tahan kalau field-nya ditulis providerName
    providerName(record) {
      const name = pick(record, "provider_name");

      return name == null ? "" : name;
    },
    // nilai bisa array (beberapa nomor) atau satu nilai saja — diseragamkan
    // jadi array supaya template-nya tidak perlu bercabang. nilai kosong
    // menghasilkan array kosong, jadi tidak ada icon telepon yang menggantung
    // tanpa nomor.
    toList(text) {
      if (Array.isArray(text)) {
        return text;
      }

      return text == null || text === "" ? [] : [text];
    },
    isYes(text) {
      return FLAG_YES.indexOf(String(text).trim().toLowerCase()) != -1;
    },
    isNo(text) {
      return FLAG_NO.indexOf(String(text).trim().toLowerCase()) != -1;
    },
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.pageSize = pageSize;
      this.handlePageChange(current);
    },
    handlePageChange(page) {
      this.page = page;

      this.fetch({
        page: this.page,
        pageSizes: this.pageSize,
        id: this.$route.params.id,
        ...this.searchParam(),
      });

      this.$router.push({
        query: {
          page: this.page,
          pageSizes: this.pageSize,
          ...this.searchParam(),
        },
      });
    },
    // search kosong tidak dikirim, biar query string tetap bersih
    searchParam() {
      return this.search != "" ? { search: this.search } : {};
    },
    onSearch(value) {
      this.search = value;
      this.page = 1;

      this.fetch({
        page: this.page,
        pageSizes: this.pageSize,
        id: this.$route.params.id,
        ...this.searchParam(),
      });

      this.$router.push({
        query: {
          page: this.page,
          pageSizes: this.pageSize,
          ...this.searchParam(),
        },
      });
    },
    fetch(params = {}) {
      this.loading = true;
      this.$store
        .dispatch("GetProvider", {
          ...params,
        })
        .then((response) => {
          this.loading = false;
          this.data = response.data.data;

          // endpoint ini menaruh info paging di response.data.pagination,
          // bukan di root seperti /perusahaan. total wajib angka — kalau NaN
          // masuk ke prop :total, antd menghitung jumlah halaman jadi NaN
          const pagination = response.data.pagination;
          const total =
            pagination == undefined ? NaN : Number(pagination.total);

          this.total = Number.isFinite(total) ? total : 0;

          // kalau hasil search kosong, header kolom dipertahankan
          if (this.data != undefined && this.data.length > 0) {
            this.columns = this.buildColumns(this.data);
          }

          this.measure();
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<!-- sengaja tidak scoped: a-icon me-render <i> milik ant-design-vue, jadi
     attribute scope-nya tidak selalu kena. nama class sudah spesifik. -->
<style>
/* search nempel di atas, header kolom nempel persis di bawahnya.
   scroll tetap milik simplebar (halaman), bukan body tabel. */
/* jarak 14px-nya dipindah dari margin-top .ant-table-wrapper ke padding blok
   sticky. dengan begitu area kosong itu ikut tertutup background putih saat
   menempel, jadi header tidak mepet ke search dan baris tabel tidak menembus.
   offsetHeight yang dipakai measure() sudah termasuk padding ini. */
._providersticky {
  position: sticky;
  top: 0;
  z-index: 3;
  background: #ffffff;
  padding-bottom: 14px;
}

._providertable {
  margin-top: 0 !important;
}

/* style.css:2038 memberi .ant-table `overflow: hidden`, yang membuat elemen itu
   jadi scrollport-nya sticky. karena .ant-table tidak pernah scroll, header
   tidak akan nempel — jadi khusus tabel ini overflow-nya dilepas. */
._providertable .ant-table {
  overflow: visible !important;
}

/* radius sudut kanan atas tadinya hasil clipping .ant-table, dikembalikan
   langsung ke cell-nya (sudut kiri sudah punya rule sendiri di style.css:608) */
._providertable .ant-table-thead > tr:first-child > th:last-child {
  border-top-right-radius: 16px;
}

._providertable .ant-table-thead > tr > th {
  position: sticky;
  top: var(--sticky-top, 72px);
  z-index: 2;
}

/* pakai margin-right, bukan gap: gap pada flex baru didukung Chrome 84+
   sedangkan browserslist project ini masih longgar */
.ant-table ._phonecell {
  display: flex;
  align-items: center;
}

.ant-table ._phonecell + ._phonecell {
  margin-top: 0.25rem;
}

.ant-table ._phoneicon {
  margin-right: 0.375rem;
  color: #77849d !important;
  font-size: 13px;
}

.ant-table ._flagyes,
.ant-table ._flagno {
  font-size: 20px !important;
}

.ant-table ._flagyes {
  color: #00ba6a !important;
}

.ant-table ._flagno {
  color: #fa0000 !important;
}
</style>
